
import { getApiVersion } from './config.js'
import { makeGetRequest, makePostRequest, makePutRequest, makeDeleteRequest } from './util.js'

function getProgram(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.districtCode) filteredQueryParams.district = queryParams.districtCode
  return makeGetRequest(`${getApiVersion()}/program`, filteredQueryParams)
}

function getBuilding(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.district_id) filteredQueryParams.district_id = queryParams.districtId
  if (queryParams?.address) filteredQueryParams.address = queryParams.address
  return makeGetRequest(`${getApiVersion()}/building`, filteredQueryParams)
}

function getBuildingProgramTime(id) {
  return makeGetRequest(`${getApiVersion()}/building_program_time/id/${id}`)
}

function getRoutedBuilding() {
  return makeGetRequest(`${getApiVersion()}/routed_building`)
}

function getStudent(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.date) filteredQueryParams.date = queryParams.date
  if (queryParams?.dbId) filteredQueryParams.db_id = queryParams.dbId
  return makeGetRequest(`${getApiVersion()}/student`, filteredQueryParams)
}

function getContact(dbId) {
  return makeGetRequest(`${getApiVersion()}/contact/${dbId}`)
}

function getStudentNotes(id) {
  return makeGetRequest(`${getApiVersion()}/student_note/${id}`)
}

function getStudentData(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.date) filteredQueryParams.date = queryParams.date
  if (queryParams?.perPage) filteredQueryParams.per_page = queryParams.perPage
  if (queryParams?.page) filteredQueryParams.page = queryParams.page
  if (queryParams?.search) filteredQueryParams.search = queryParams.search
  if (queryParams?.sortBy) filteredQueryParams.order_by = queryParams.sortBy
  return makeGetRequest(`${getApiVersion()}/student_data`, filteredQueryParams)
}

function getStudentDetail(data, queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.select) {
    switch (queryParams.select) {
      case 'scheduleRequest':
        filteredQueryParams.select = 'schedule_request'
        break
      case 'studentInfo':
        filteredQueryParams.select = 'student_info'
        break
    }
  }
  return makeGetRequest(`${getApiVersion()}/student_data_detail/id/${data}`, filteredQueryParams)
}

function getOneTimeNoRideData(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.startDate) filteredQueryParams.start_date = queryParams.startDate
  if (queryParams?.endDate) filteredQueryParams.end_date = queryParams.endDate
  if (queryParams?.page) filteredQueryParams.page = queryParams.page
  if (queryParams?.search) filteredQueryParams.search = queryParams.search
  if (queryParams?.sortBy) filteredQueryParams.order_by = queryParams.sortBy
  if (queryParams?.filterBy) filteredQueryParams.filter_by = queryParams.filterBy
  return makeGetRequest(`${getApiVersion()}/one_time_no_ride_data`, filteredQueryParams)
}

function getOneTimeNoRideFilters() {
  var filteredQueryParams = {}
  return makeGetRequest(`${getApiVersion()}/one_time_no_ride_filters`, filteredQueryParams)
}

function getDailyNoShowData(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.startDate) filteredQueryParams.start_date = queryParams.startDate
  if (queryParams?.endDate) filteredQueryParams.end_date = queryParams.endDate
  if (queryParams?.page) filteredQueryParams.page = queryParams.page
  if (queryParams?.search) filteredQueryParams.search = queryParams.search
  if (queryParams?.sortBy) filteredQueryParams.order_by = queryParams.sortBy
  if (queryParams?.filterBy) filteredQueryParams.filter_by = queryParams.filterBy
  return makeGetRequest(`${getApiVersion()}/daily_no_show_data`, filteredQueryParams)
}

function getDailyNoShowFilters() {
  var filteredQueryParams = {}
  return makeGetRequest(`${getApiVersion()}/daily_no_show_filters`, filteredQueryParams)
}

function getStudentLastRequestComplete(dbId) {
  return makeGetRequest(`${getApiVersion()}/student_last_request_complete/${dbId}`)
}

function getScheduleRequest(dbId, queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.sortBy) filteredQueryParams.order_by = queryParams.sortBy
  return makeGetRequest(`${getApiVersion()}/schedule_request/${dbId}`, filteredQueryParams)
}

function getScheduleRequestStatus(dbId) {
  var filteredQueryParams = {}
  return makeGetRequest(`${getApiVersion()}/schedule_request/status/${dbId}`, filteredQueryParams)
}

function getRouteNotificationInfo(dbId) {
  var filteredQueryParams = {}
  return makeGetRequest(`${getApiVersion()}/route_notification/${dbId}`, filteredQueryParams)
}

function getRouteNotificationInfoDiff(dbId) {
  var filteredQueryParams = {}
  return makeGetRequest(`${getApiVersion()}/route_notification_diff/${dbId}`, filteredQueryParams)
}

function getStudentInfo(dbId, queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.sortBy) filteredQueryParams.order_by = queryParams.sortBy
  return makeGetRequest(`${getApiVersion()}/student_info/${dbId}`, filteredQueryParams)
}

function getRouteInfo(routeId, queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.sortBy) filteredQueryParams.order_by = queryParams.sortBy
  if (queryParams?.dbId) filteredQueryParams.db_id = queryParams.dbId
  return makeGetRequest(`${getApiVersion()}/route_info/${routeId}`, filteredQueryParams)
}

function getVendor(code) {
  return makeGetRequest(`${getApiVersion()}/vendor`, {
    code: code,
  })
}

function getVendorDetail(vendorId) {
  return makeGetRequest(`${getApiVersion()}/vendor_detail/${vendorId}`)
}

function getVehicleData(queryParams){
  var filteredQueryParams = {}
  if (queryParams?.perPage) filteredQueryParams.per_page = queryParams.perPage
  if (queryParams?.page) filteredQueryParams.page = queryParams.page
  if (queryParams?.sortBy) filteredQueryParams.order_by = queryParams.sortBy
  if (queryParams?.search) filteredQueryParams.search = queryParams.search
  if (queryParams?.filterBy) filteredQueryParams.filter_by = queryParams.filterBy
  return makeGetRequest(`${getApiVersion()}/vehicle_data`, filteredQueryParams)
}

function getRouteData(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.date) filteredQueryParams.date = queryParams.date
  if (queryParams?.time) filteredQueryParams.time = queryParams.time
  if (queryParams?.perPage) filteredQueryParams.per_page = queryParams.perPage
  if (queryParams?.page) filteredQueryParams.page = queryParams.page
  if (queryParams?.sortBy) filteredQueryParams.order_by = queryParams.sortBy
  if (queryParams?.search) filteredQueryParams.search = queryParams.search
  if (queryParams?.filterBy) filteredQueryParams.filter_by = queryParams.filterBy
  return makeGetRequest(`${getApiVersion()}/route_data`, filteredQueryParams)
}

function postRouteStatus(data) {
  return makePostRequest(`${getApiVersion()}/route_status_list`, data)
}

function getDriverData(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.date) filteredQueryParams.date = queryParams.date
  if (queryParams?.perPage) filteredQueryParams.per_page = queryParams.perPage
  if (queryParams?.page) filteredQueryParams.page = queryParams.page
  if (queryParams?.sortBy) filteredQueryParams.order_by = queryParams.sortBy
  if (queryParams?.search) filteredQueryParams.search = queryParams.search
  if (queryParams?.filterBy) filteredQueryParams.filter_by = queryParams.filterBy
  return makeGetRequest(`${getApiVersion()}/driver_data`, filteredQueryParams)
}

function getDriverDetail(dbId) {
  return makeGetRequest(`${getApiVersion()}/driver_detail/${dbId}`)
}

function putDriverDetail(dbId, data) {
  var filteredData = {}
  if (data?.action) filteredData.action = data.action
  if (data && 'value' in data) filteredData.value = data.value
  return makePutRequest(`${getApiVersion()}/driver_detail/${dbId}`, filteredData)
}

function getVehicleDetail(dbId) {
  return makeGetRequest(`${getApiVersion()}/vehicle_detail/${dbId}`)
}

function getVehicleModelList() {
  return makeGetRequest(`${getApiVersion()}/vehicle_model_list`)
}

function getDriverRequirements(vendorId){
  return makeGetRequest(`${getApiVersion()}/driver_requirements/${vendorId}`)
}

function getGoogleCredentials(){
  return makeGetRequest(`${getApiVersion()}/google_credentials`)
}

function getSchoolYear() {
  return makeGetRequest(`${getApiVersion()}/school_year`)
}

function getDistrict() {
  return makeGetRequest(`${getApiVersion()}/district`)
}

function getDistrictDetail(code) {
  return makeGetRequest(`${getApiVersion()}/district_detail/${code}`)
}

function getEvent(basedOn, data) {
  return makeGetRequest(`${getApiVersion()}/calendar_event/${basedOn}/${data}`)
}

function getSupervisorList() {
  return makeGetRequest(`${getApiVersion()}/supervisor_list`)
}

function getAllEvents() {
  return makeGetRequest(`${getApiVersion()}/all_events`)
}

function getUser() {
  return makeGetRequest(`${getApiVersion()}/user`)
}

function getUserView() {
  return makeGetRequest(`${getApiVersion()}/user/view`)
}

function getViewUiData() {
  return makeGetRequest(`${getApiVersion()}/user/view/ui_data`)
}

function postUserView(data) {
  var filteredData = {}
  if (data?.userId !== undefined) filteredData.user_id = data.userId
  if (data?.view !== undefined) filteredData.view = data.view
  return makePostRequest(`${getApiVersion()}/user/view`, filteredData)
}

function getUserViewOptions(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.schoolYear) filteredQueryParams.school_year = queryParams.schoolYear
  if (queryParams?.vendor) filteredQueryParams.vendor = queryParams.vendor
  if (queryParams?.district) filteredQueryParams.district = queryParams.district
  if (queryParams?.partition) filteredQueryParams.partition = queryParams.partition
  if (queryParams?.building) filteredQueryParams.building = queryParams.building
  return makeGetRequest(`${getApiVersion()}/user/view/options`, filteredQueryParams)
}

function getUserCapabilities() {
  return makeGetRequest(`${getApiVersion()}/user_capabilities`)
}

function getPartition() {
  // var filteredQueryParams = {}
  // if (queryParams?.dbId) filteredQueryParams.db_id = queryParams.dbId
  return makeGetRequest(`${getApiVersion()}/partition`)
}

function postNewStudentForm(data) {
  return makePostRequest(`${getApiVersion()}/new_request_form`, data)
}

function putChangeStudentForm(data, id) {
  return makePutRequest(`${getApiVersion()}/new_request_form/${id}`, data)
}

function putChangeMeta(data) {
  return makePutRequest(`${getApiVersion()}/user/meta`, data)
}

function putStudentNotes(data, id) {
  return makePutRequest(`${getApiVersion()}/student_note/${id}`, data)
}

function putDriverForm(id, data) {
  return makePutRequest(`${getApiVersion()}/update_driver/${id}`, data)
}

function putDriverFile(id, data) {
  return makePutRequest(`${getApiVersion()}/driver_document/${id}`, data)
}

function putVehicleForm(id, data) {
  return makePutRequest(`${getApiVersion()}/vehicle_form/${id}`, data)
}

function deleteDriverFile(driverId, fileId) {
  return makeDeleteRequest(`${getApiVersion()}/driver_document/${driverId}/${fileId}`)
}

function postNewOneTimeRideForm(data) {
  return makePostRequest(`${getApiVersion()}/one_time_ride_form`, data)
}

function postNewOneTimeNoRideForm(data) {
  return makePostRequest(`${getApiVersion()}/one_time_no_ride_form`, data)
}

function postNewLateRouteForm(data) {
  return makePostRequest(`${getApiVersion()}/late_route_form`, data)
}

function postDriverForm(data) {
  return makePostRequest(`${getApiVersion()}/create_driver`, data)
}

function postVehicleForm(data) {
  return makePostRequest(`${getApiVersion()}/vehicle_form`, data)
}

function postUpdateContact(data, dbId) {
  return makePostRequest(`${getApiVersion()}/update_contact/${dbId}`, data)
}

function getNewLateRouteSequence(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.date) filteredQueryParams.date = queryParams.date
  if (queryParams?.vehicleId)
    filteredQueryParams.vehicle_id = queryParams.vehicleId
  if (queryParams?.buildingId)
    filteredQueryParams.building_id = queryParams.buildingId
  return makeGetRequest(`${getApiVersion()}/late_route_sequence`, filteredQueryParams)
}

function getVehicles(vendorId) {
  return makeGetRequest(`${getApiVersion()}/vehicle/${vendorId}`)
}

function getLateRoutesSheetData() {
  return makeGetRequest(`${getApiVersion()}/late_routes_sheet`)
}

function putLateRoutesSheetData(data) {
  return makePutRequest(`${getApiVersion()}/late_routes_sheet`, data)
}

function postNewDailyNoShowForm(data) {
  return makePostRequest(`${getApiVersion()}/daily_no_show_form`, data)
}

function checkRequestFormStartDateWarning(data) {
  return makePostRequest(`${getApiVersion()}/request_form/start_date_warning`, data)
}

function getNewDailyNoShowSequence(queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.date) filteredQueryParams.date = queryParams.date
  if (queryParams?.vehicleId)
    filteredQueryParams.vehicle_id = queryParams.vehicleId
  if (queryParams?.buildingId)
    filteredQueryParams.building_id = queryParams.buildingId
  return makeGetRequest(`${getApiVersion()}/daily_no_show_sequence`, filteredQueryParams)
}

function postNewCalendarEvent(data) {
  return makePostRequest(`${getApiVersion()}/calendar_event`, data)
}

function postNewStudentNote(data, id) {
  return makePostRequest(`${getApiVersion()}/student_note/${id}`, data)
}

function postCheckStudent(data) {
  return makePostRequest(`${getApiVersion()}/check_student`, data)
}

function postNewCancelForm(data, id) {
  return makePostRequest(`${getApiVersion()}/schedule_cancel_form/${id}`, data)
}

function postPartition(data) {
  return makePostRequest(`${getApiVersion()}/partition`, data)
}

function postScheduleRequestStatus(data, dbId) {
  return makePostRequest(`${getApiVersion()}/schedule_request/status/${dbId}`, data)
}

function postRouteNotificationInfo(data, dbId) {
  return makePostRequest(`${getApiVersion()}/route_notification/${dbId}`, data)
}

function deleteCalendarEvent(dbId) {
  return makeDeleteRequest(`${getApiVersion()}/calendar_event_id/${dbId}`)
}

function getVendorLinks() {
  return makeGetRequest(`${getApiVersion()}/vendor_links`)
}

export {
  getProgram,
  getBuilding,
  getBuildingProgramTime,
  getRoutedBuilding,
  getStudentNotes,
  getStudent,
  getContact,
  getStudentData,
  getStudentDetail,
  getSupervisorList,
  getOneTimeNoRideData,
  getOneTimeNoRideFilters,
  getDailyNoShowData,
  getDailyNoShowFilters,
  getStudentLastRequestComplete,
  getScheduleRequest,
  getScheduleRequestStatus,
  getRouteNotificationInfo,
  getRouteNotificationInfoDiff,
  getStudentInfo,
  getRouteInfo,
  getVendor,
  getVehicles,
  getVendorDetail,
  getVehicleData,
  postVehicleForm,
  putVehicleForm,
  getVehicleDetail,
  getVehicleModelList,
  getRouteData,
  postRouteStatus,
  getDriverData,
  getDriverDetail,
  putDriverDetail,
  putDriverForm,
  postDriverForm,
  putDriverFile,
  deleteDriverFile,
  getDriverRequirements,
  getGoogleCredentials,
  getSchoolYear,
  getDistrict,
  getDistrictDetail,
  getEvent,
  getAllEvents,
  getUser,
  getUserView,
  getViewUiData,
  postUserView,
  getUserViewOptions,
  getUserCapabilities,
  getPartition,
  postNewStudentForm,
  putChangeStudentForm,
  putChangeMeta,
  putStudentNotes,
  postNewOneTimeRideForm,
  postNewOneTimeNoRideForm,
  postNewLateRouteForm,
  getNewLateRouteSequence,
  postNewDailyNoShowForm,
  getNewDailyNoShowSequence,
  postNewCalendarEvent,
  postNewStudentNote,
  postNewCancelForm,
  postUpdateContact,
  postCheckStudent,
  postPartition,
  postScheduleRequestStatus,
  postRouteNotificationInfo,
  deleteCalendarEvent,
  getLateRoutesSheetData,
  putLateRoutesSheetData,
  getVendorLinks,
  checkRequestFormStartDateWarning,
}
